import { useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import { postCzMaxPriceExportXls } from '~/libs/infrastructure/api/users/czMaxPrice';
import downloadFileFromUrl from '~/utils/Download/downloadFileFromUrl';
import { useCzMaxPriceExportError } from './czMaxPriceExportErrors';

export function useCzMaxPriceExport(userId: string, groupId: string) {
	const handleExportError = useCzMaxPriceExportError();

	const mutation = useMutation({
		mutationFn: () => postCzMaxPriceExportXls(userId, groupId),
	});
	const mutationRef = useRef(mutation);
	mutationRef.current = mutation;

	async function triggerExport() {
		try {
			const response = await mutationRef.current.mutateAsync();
			if (response.export == null) {
				handleExportError(new Error('Export response missing export payload'));
				return;
			}
			if (response.export.downloadUrl !== null) {
				downloadFileFromUrl(response.export.downloadUrl);
			}
		} catch (error: unknown) {
			handleExportError(error);
		}
	}

	return { triggerExport };
}
